module.exports = __webpack_public_path__ + "img/delphinus-logo.55c71bae.png";